import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  lockscreenSection: {
    padding: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  lockscreenSettings: {
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderColor: colors.newUI.therapist.bgBlue10,
  },
});
